import PrivateRoute, { Router } from 'components/app-layout/PrivateRoute';

import SitesGrid from '../components/Grid';
import { SiteProvider } from '../store';

import SiteFormLayout from './Form';

export default function SitesGridLayout() {
  return <SiteProvider>
    <SitesGrid />
    <Router>
      <PrivateRoute path={["/admin/sites/add", "/admin/sites/:id"]} component={SiteFormLayout} />
    </Router>
  </SiteProvider>;
}
